import { render, staticRenderFns } from "./AcademicCharge.vue?vue&type=template&id=59ebe466"
import script from "./AcademicCharge.vue?vue&type=script&lang=js"
export * from "./AcademicCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports